import { ChainId, chainNames } from '@pancakeswap/chains'
import { ChainDefaultId } from '@pancakeswap/sdk'
import memoize from 'lodash/memoize'
import { Chain, pulsechain, pulsechainV4 } from 'wagmi/chains'
// import NineInchConfig from '@9inch/config'

export const CHAIN_QUERY_NAME = chainNames

const CHAIN_QUERY_NAME_TO_ID = Object.entries(CHAIN_QUERY_NAME).reduce((acc, [chainId, chainName]) => {
  return {
    [chainName.toLowerCase()]: chainId as unknown as ChainId,
    ...acc,
  }
}, {} as Record<string, ChainId>)

export const getChainId = memoize((chainName: string) => {
  if (!chainName) return ChainDefaultId
  return CHAIN_QUERY_NAME_TO_ID[chainName.toLowerCase()] ? +CHAIN_QUERY_NAME_TO_ID[chainName.toLowerCase()] : ChainDefaultId
})

export const pulse = {
  ...pulsechain,
  rpcUrls: {
    ...pulsechain.rpcUrls,
    public: {
      http: [
        "https://pulsechain-rpc.publicnode.com",
        "https://rpc-pulsechain.g4mm4.io",
        "https://rpc.pulsechain.com"
      ],
      webSocket: ['wss://pulsechain-rpc.publicnode.com'],
    },
  },
} as const satisfies Chain

export const testnet = {
  ...pulsechainV4,
  rpcUrls: {
    ...pulsechainV4.rpcUrls,
    public: {
      http: [
        "https://rpc-testnet-pulsechain.g4mm4.io",
        "https://rpc.v4.testnet.pulsechain.com",
        "https://pulsechain-testnet-rpc.publicnode.com"
      ],
      webSocket: ['wss://rpc-pulsechain.g4mm4.io'],
    },
  },
  testnet: true,
} as const satisfies Chain

/**
 * Controls some L2 specific behavior, e.g. slippage tolerance, special UI behavior.
 * The expectation is that all of these networks have immediate transaction confirmation.
 */
export const L2_CHAIN_IDS: ChainId[] = [
]

export const CHAINS = [pulse].filter(chain => chain.id === Number(ChainDefaultId))
